/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Blog_Ai_OverwriteInputs */

const cs_blog_ai_overwrite = /** @type {(inputs: Blog_Ai_OverwriteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Přepsat existující text`)
};

const en_blog_ai_overwrite = /** @type {(inputs: Blog_Ai_OverwriteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Overwrite existing text`)
};

/**
* | output |
* | --- |
* | "Overwrite existing text" |
*
* @param {Blog_Ai_OverwriteInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const blog_ai_overwrite = /** @type {((inputs?: Blog_Ai_OverwriteInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Blog_Ai_OverwriteInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_blog_ai_overwrite(inputs)
	return cs_blog_ai_overwrite(inputs)
});